import { Path } from '@/main/router/routerPath';

import CaskPredplatneList from './CaskPredplatneList.vue';
import SqlLog from './SlqLog.vue';
import ChybovyLogList from './ChybovyLogList.vue';

export const router = new Path().addChildren([
	new Path('SqlLog', SqlLog, 'ADM_SqlLog', 'SqlLog'),

	new Path('CaskPredplatne', { List: CaskPredplatneList }, 'ADM_CaskPredplatne'),
	new Path('ChybovyLog', { List: ChybovyLogList }, 'ADM_ChybovyLog'),
]);
